import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function returns the translation key for the given measurement statement.
 * @param statement
 * @returns
 */
export function getMeasurementStatementTranslationKey(
	statement: Enums<"ticketAssignmentMeasurementStatement">,
): TranslationKey {
	switch (statement) {
		case "remember":
			return "measurements.options.remember";
		case "without-charge":
			return "measurements.options.without_charge";
		case "included":
			return "measurements.options.included";
	}
}
